export default {
  wrapperPadding: '1.5rem 0 0.5rem',
};
